import { render, staticRenderFns } from "./ProducaoFiltro.vue?vue&type=template&id=0b0b4a26"
import script from "./ProducaoFiltro.vue?vue&type=script&lang=ts"
export * from "./ProducaoFiltro.vue?vue&type=script&lang=ts"
import style0 from "./ProducaoFiltro.vue?vue&type=style&index=0&id=0b0b4a26&prod&lang=css"
import style1 from "./ProducaoFiltro.vue?vue&type=style&index=1&id=0b0b4a26&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports